import React, { FC, PropsWithChildren } from "react"
import styled from "styled-components"
import Container from "../container"
import { getThemeColor } from "../../utils/styles"

export const DividedContent: FC<PropsWithChildren> = (props) => {
  const { children } = props

  return React.Children.map(children, (child, index) => {
    return (
      <>
        {index !== 0 && (
          <Container large>
            <StyledDivider />
          </Container>
        )}
        {child}
      </>
    )
  })
}

const StyledDivider = styled.div`
  background-color: ${getThemeColor("grey2")};
  height: 1px;
`
